<template>
    <div class="trustpilot-card">
        <img class="trustpilot-logo" src="@img/Trustpilot_logo.png" alt="" />
        <p class="trustpilot-text"
            >The L&G Life Insurance product is rated "Excellent" on Trustpilot
        </p>
    </div>
</template>

<style scoped>
.trustpilot-card {
    display: flex;
    flex-direction: column;
    gap: 2rem;
    border-radius: 5px;
    background: var(--color-primary);
    max-width: 285px;
    min-width: 200px;
    padding: 1rem;

    .trustpilot-logo {
        width: 100%;
    }

    .trustpilot-text {
        color: var(--off-white);
        text-align: center;
        font-size: 1.25rem;
        font-weight: 800;
    }
}
</style>
